@if (actionError(); as message) {
  <div hlmAlert variant="destructive">
    <ng-icon name="lucideTriangleAlert" />
    <p hlmAlertDescription>{{ message }}</p>
  </div>
}
@if (error(); as message) {
  <div hlmAlert variant="destructive">
    <ng-icon name="lucideTriangleAlert" />
    <p hlmAlertTitle>{{ message }}</p>
    <p hlmAlertDescription>
      <button hlmBtn variant="link" size="sm" type="button" (click)="load()">
        Erneut versuchen
      </button>
    </p>
  </div>
}
<app-design-library
  [designs]="designs()"
  [loading]="loading()"
  [busyId]="busyId()"
  [previewingId]="previewingId()"
  (activate)="activate($event)"
  (copy)="copy($event)"
  (delete)="askDelete($event)"
  (preview)="previewPdf($event)"
  (create)="newDesignType.set($event)" />

<app-new-design-dialog
  [open]="newDesignType() !== null"
  [initialType]="newDesignType() ?? 'money'"
  (created)="onCreated($event)"
  (close)="newDesignType.set(null)" />

<hlm-alert-dialog [state]="pending() ? 'open' : 'closed'" (stateChanged)="onDialogState($event)">
  <hlm-alert-dialog-content *hlmAlertDialogPortal class="max-w-lg">
    <div hlmAlertDialogHeader>
      <h3 hlmAlertDialogTitle>{{ dialogTitle() }}</h3>
      <p hlmAlertDialogDescription>Das Design und sein Layout werden endgültig gelöscht.</p>
    </div>
    <div hlmAlertDialogFooter>
      <button hlmAlertDialogCancel hlmBtn variant="outline" (click)="cancelPending()">
        Abbrechen
      </button>
      <button hlmAlertDialogAction hlmBtn variant="destructive" (click)="confirmPending()">
        Löschen
      </button>
    </div>
  </hlm-alert-dialog-content>
</hlm-alert-dialog>
